document.addEventListener('DOMContentLoaded', () => {
  initializeFitSizes();
  initializeFitPredictor();
  initializeProductAccordion();
  // initializeProductRecommendation();
  startCountdownTimers();
});
document.addEventListener('variants:change', (event) => {
  let variant = event.detail.variant;
  let form = event.detail.form;
  initializeFitSizes();
  initializeFitPredictor();
  initializePreorder(event.detail);
  
  // console.log(variant);
  // const notifyBtn = document.querySelector('#BIS_trigger');
  // if (notifyBtn) {
  //   notifyBtn.toggleAttribute('hidden', variant.available);
  //   notifyBtn.setAttribute('data-variant-id', variant.id);
  // }
});
// document.addEventListener('product:recommendations:loaded', function (event) {
//   initializeProductRecommendation();
// });

// Runs Small Start
// function initializeFitPredictor() {
//   const sizeRadios = document.querySelectorAll('product-info variant-selects .size-variant-option [type="radio"]');
//   const runsSmallWrapper = document.querySelector('.runs-small-wrapper');
//   const runsBigWrapper = document.querySelector('.runs-big-wrapper');
//   if (runsSmallWrapper) {
//     sizeRadios.forEach(radio => {
//       radio.addEventListener('click', function () {
//         const currentSize = this.value;
  
//         if (window.runsSmall != null) {
//           if (window.runsSmall.includes(currentSize)) {
//             runsSmallWrapper.classList.remove('hidden');
//           } else {
//             runsSmallWrapper.classList.add('hidden');
//           }
//         } else {
//           runsSmallWrapper.classList.add('hidden');
//         }
//       });
//     });
//   }
//   if (runsBigWrapper) {
//     sizeRadios.forEach(radio => {
//       radio.addEventListener('click', function () {
//         const currentSize = this.value;
  
//         if (window.runsBig != null) {
//           if (window.runsBig.includes(currentSize)) {
//             runsBigWrapper.classList.remove('hidden');
//           } else {
//             runsBigWrapper.classList.add('hidden');
//           }
//         } else {
//           runsBigWrapper.classList.add('hidden');
//         }
//       });
//     });
//   }
// }
// Runs Small End

// Runs Small Start
function initializeFitPredictor() {
  const radios = document.querySelectorAll('product-info variant-selects .size-variant-option [type="radio"]');
  const wrappers = {
    small: document.querySelector('.runs-small-wrapper'),
    big: document.querySelector('.runs-big-wrapper')
  };

  radios.forEach(radio => {
    radio.addEventListener('click', () => {
      const size = radio.value;

      if (wrappers.small)
        wrappers.small.classList.toggle('hidden', !(window.runsSmall || []).includes(size));
      if (wrappers.big)
        wrappers.big.classList.toggle('hidden', !(window.runsBig || []).includes(size));
    });
  });
}
// Runs Small End

// Preorder Start
function initializePreorder(detail) {
  if (!detail?.variant || !detail?.form || !window?.ProductInventory || !window?.variantStrings) return;

  const variant = detail.variant;
  const form = detail.form;
  const sectionId = form.sectionId;
  const preorderFlag = form.querySelector(`#Preorder_${sectionId}`);
  const submitButtonText = form.querySelector(`#ProductSubmitButton-${sectionId} span`);

  if (!preorderFlag || !submitButtonText) return;

  const variantData = window.ProductInventory.variants.find(v => v.id == variant.id);

  if (!variant.available || !variantData) return;

  if (variantData.isPreorder) {
    preorderFlag.classList.remove('hidden');
    submitButtonText.textContent = window.variantStrings.preorder;
  } else {
    preorderFlag.classList.add('hidden');
    submitButtonText.textContent = window.variantStrings.addToCart;
  }
}
// Preorder End

// Fit Sizes Start
function initializeFitSizes() {
  const sizeRadios = document.querySelectorAll('product-info variant-selects .size-variant-option [type="radio"]');
  const fitSizesEl = document.getElementById('fit_sizes_data');
  const fitSizesBox = document.querySelector('.fit_sizes');
  const fitSizeContent = document.querySelector('.fit_size_content');

  // Exit if required elements are missing
  if (!fitSizesEl || !fitSizesBox || !fitSizeContent || sizeRadios.length === 0) {
    console.warn('[Fit Sizes] Required elements not found. Skipping initialization.');
    return;
  }

  let fitSizesData;

  try {
    fitSizesData = JSON.parse(fitSizesEl.textContent);
  } catch (e) {
    console.error('[Fit Sizes] Error parsing JSON:', e);
    return;
  }

  sizeRadios.forEach(radio => {
    radio.addEventListener('click', function () {
      const currentSize = this.value.replaceAll('-', '/');
      const matchedSize = fitSizesData.find(item => item.size === currentSize);

      if (matchedSize) {
        fitSizeContent.innerHTML = matchedSize.size_content;
        fitSizesBox.classList.remove('hidden');
      } else {
        fitSizeContent.innerHTML = '';
        fitSizesBox.classList.add('hidden');
      }
    });
  });
}
// Fit Sizes End

// Product Details Accordion Start
function initializeProductAccordion(){
  const accordions = document.querySelectorAll('.product-accordion');

  accordions.forEach(accordion => {
    const heading = accordion.querySelector('.accordion-heading');
    
    // Click event for heading
    heading.addEventListener('click', function() {
      // Toggle only the clicked accordion
      if (accordion.classList.contains('open')) {
        accordion.classList.remove('open');
      } else {
        accordion.classList.add('open');
      }
    });
  });
}
// Product Details Accordion End

// function initializeProductRecommendation() {
//   if (document.getElementById('stamped-script-widget')) {
//     document.getElementById('stamped-script-widget').remove();
//   }

//   const script = document.createElement('script');
//   script.async = true;
//   script.type = 'text/javascript';
//   script.id = 'stamped-script-widget';
//   script.setAttribute('data-api-key', 'pubkey-hzC7I8Grcgz37JAD40N5362m4kD681');
//   script.src = 'https://cdn1.stamped.io/files/widget.min.js';

//   document.body.appendChild(script);
//   console.log('Stamped script reinjected via custom event');
// }

// Sale Timer Start
function startCountdownTimers() {
  const timers = document.querySelectorAll('.countdown-timer-wrapper');

  if (timers.length === 0) return; // Exit early if no timers found

  timers.forEach(wrapper => {
    const output = wrapper.querySelector('.timer-output');
    const endTime = wrapper.getAttribute('data-end-time');

    if (!endTime) {
      console.warn('[Countdown Timer] Missing data-end-time attribute.');
      return;
    }

    const countDownDate = new Date(endTime.replace(/\s/, 'T')).getTime();

    if (isNaN(countDownDate)) {
      console.warn('[Countdown Timer] Invalid date:', endTime);
      return;
    }

    // Remove hidden class right away if timer is valid
    wrapper.classList.remove('hidden');

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      if (distance < 0) {
        clearInterval(interval);
        wrapper.classList.add('hidden');
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      output.innerText = days <= 0
        ? `${hours}h ${minutes}m ${seconds}s`
        : `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }, 1000);
  });
}
// Sale Timer End


// Addtocart sticky Start
$(document).ready(function () {
  $(window).on("scroll", function () {
    const headerHeight = $('sticky-header').outerHeight() || 0; // Fix: selector was missing a dot
    const $atc = $('.product-form__buttons');
    const isVisible = $atc.is(':visible');

    if (!$atc.length || !isVisible) return;

    const atcPosition = $atc.offset().top + $atc.outerHeight();

    if ($(window).scrollTop() + headerHeight > atcPosition) {
      $(".product-sticky-atc-bar").addClass("active");
      $("body").addClass("add-to-sticky");
    } else {
      $(".product-sticky-atc-bar").removeClass("active");
      $("body").removeClass("add-to-sticky");
    }
  });
  
  $('.product-sticky-atc-bar').on('click', '.add-to-btn, .add-default-btn', function () {
    const isDisabled = $(this).is('[disabled]');
    if (isDisabled) {
      const scrollPos = $('variant-selects').offset().top - ($('sticky-header').outerHeight() || 0);
      $("html, body").animate({ scrollTop: scrollPos }, 1000);
    } else {
      $('.product-form__submit').trigger('click');
    }
  });
});
// Addtocart Sticky End


// Multi Buy Products Start
document.addEventListener('cart:updated', async function(event) {
  const { detail: cartJSON, detail: { source } } = event;
  if (source === 'add-to-cart' || source === 'cart-change') {
    const cart = source === 'add-to-cart' ? await getCartJSON() : cartJSON.data;
    updateMultiBuyProduct(cart);
  }
});

async function updateMultiBuyProduct(cart) {
  if (!cart) return;

  const el = document.getElementById('multibuy-pricing-product');
  const content = document.querySelector('.MPP-head-content');
  const mixText = el.getAttribute('mix-match-text');
  const offers = [1, 2, 3].map(i => ({
    qty: +el.getAttribute(`product-offer-${i}`),
    save: el.getAttribute(`product-offer-per-${i}`)
  }));

  if (!cart.item_count) {
    content.innerHTML = `${mixText} ${offers[0].qty} <b> save ${offers[0].save}</b>`;
    return;
  }

  let totalQty = 0, hasBundle = false;

  await Promise.all(cart.items.map(async item => {
    const product = await fetch(`/products/${item.handle}.js`).then(res => res.json());
    if (product.tags.includes('bundle')) {
      hasBundle = true;
      totalQty += item.quantity;
    }
  }));

  if (!hasBundle) {
    content.innerHTML = `${mixText} ${offers[0].qty} <b> save ${offers[0].save}</b>`;
  } else {
    const matched = offers.find(o => totalQty < o.qty) || offers[2];
    content.innerHTML = totalQty >= offers[2].qty
      ? `You've unlocked <b>${offers[2].save} off!</b>`
      : `${mixText} ${matched.qty} <b> save ${matched.save}</b>`;
  }
}
// Multi Buy Products End



